'use client';

import { c as _c } from "react/compiler-runtime";
import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import type { transformMiniProductCardEntity } from '@cc-shopping/structured-content-renderer/hydration/MiniProductCard/transform';
import type { StructuredContentDocument } from '@cc-shopping/structured-content-renderer/hydration/types';
import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { MiniProductCard as MiniProductCardBase } from 'src/features/mini-product-card';
import type * as v from 'valibot';
import type { miniProductCardSchema } from './schema';
export type MiniProductCardProps = StructuredContentDocument<v.InferInput<typeof miniProductCardSchema> & {
  marketplaceEntity: ReturnType<typeof transformMiniProductCardEntity>;
  hideReviewWhenMonetizing?: boolean;
  ctaIcon?: ReactNode;
  ctaSx?: SxProps<Theme>;
  impressionPosition?: number;
}>;
export const MiniProductCard = t0 => {
  const $ = _c(19);
  const {
    props
  } = t0;
  const {
    align,
    marketplaceEntity,
    useLargeWidth,
    hideReviewWhenMonetizing,
    ctaIcon,
    ctaSx,
    impressionPosition
  } = props;
  if (!marketplaceEntity) {
    return null;
  }
  const t1 = marketplaceEntity.ctaAnalytics?.section?.name;
  const t2 = marketplaceEntity?.details?.isActive;
  const t3 = impressionPosition ?? 0;
  const t4 = marketplaceEntity.institution?.id;
  const t5 = marketplaceEntity.institution?.name;
  const t6 = marketplaceEntity.product?.id;
  const t7 = marketplaceEntity.product?.name;
  let t8;
  if ($[0] !== align || $[1] !== ctaIcon || $[2] !== ctaSx || $[3] !== hideReviewWhenMonetizing || $[4] !== marketplaceEntity || $[5] !== useLargeWidth) {
    t8 = <MiniProductCardBase align={align} marketplaceEntity={marketplaceEntity} useLargeWidth={useLargeWidth} hideReviewWhenMonetizing={hideReviewWhenMonetizing} ctaIcon={ctaIcon} ctaSx={ctaSx} />;
    $[0] = align;
    $[1] = ctaIcon;
    $[2] = ctaSx;
    $[3] = hideReviewWhenMonetizing;
    $[4] = marketplaceEntity;
    $[5] = useLargeWidth;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== marketplaceEntity.displayName || $[8] !== marketplaceEntity.id || $[9] !== marketplaceEntity.monetizable || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <AnalyticsSkuViewed id={marketplaceEntity.id} impressionSection={t1} enabled={t2} impressionPosition={t3} institutionId={t4} institutionName={t5} monetizable={marketplaceEntity.monetizable} name={marketplaceEntity.displayName} offerId={marketplaceEntity.id} offerName={marketplaceEntity.displayName} productId={t6} productName={t7}>{t8}</AnalyticsSkuViewed>;
    $[7] = marketplaceEntity.displayName;
    $[8] = marketplaceEntity.id;
    $[9] = marketplaceEntity.monetizable;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};